'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _findInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/find');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var lodash = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _findInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_findInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);

/**
 * Provides APIs to handle GSQL loading job related business logic.
 *
 * @export
 * @class GSQLLoadingJobLogic
 */
var GSQLLoadingJobLogic = /*#__PURE__*/function () {
  function GSQLLoadingJobLogic() {
    _classCallCheck__default["default"](this, GSQLLoadingJobLogic);
  }
  return _createClass__default["default"](GSQLLoadingJobLogic, null, [{
    key: "getGSQLLoadingJobChange",
    value:
    /**
     * If, by user, a loading job logic is
     * - added:     we delete it from GSQL (swallow the error), then add it to GSQL.
     * - updated:   we delete it from GSQL, then add it to GSQL.
     * - deleted:   we delete it from GSQL.
     * - untouched: we do nothing.
     *
     * Namely, when the user touches a loading job logic, we
     * - first delete the touched GSQL loading job.
     * - then add the GSQL loading job if it's added or updated by the user.
     *
     * @static
     * @param {GSQLLoadingJobJson} savedJobs
     * @param {GSQLLoadingJobJson} inMemoryJobs
     * @returns {GSQLLoadingJobJson}
     * @memberof GSQLLoadingJobLogic
     */
    function getGSQLLoadingJobChange(savedGSQLLoadingJobs, inMemoryGSQLLoadingJobs) {
      if (lodash.isEqual(savedGSQLLoadingJobs, inMemoryGSQLLoadingJobs)) {
        return {
          isChanged: false,
          loadingJobNamesToDelete: [],
          loadingJobsToAdd: []
        };
      }

      // FIXME: GSQL needs to change the WHERE clause export format to be the same as what it received.
      var copyOfsavedGSQLLoadingJobs = GSQLLoadingJobLogic.handleWhereClause(savedGSQLLoadingJobs);
      var copyOfInMemoryGSQLLoadingJobs = GSQLLoadingJobLogic.handleWhereClause(inMemoryGSQLLoadingJobs);
      var loadingJobsAddedInMemory = lodash.differenceWith(copyOfInMemoryGSQLLoadingJobs, copyOfsavedGSQLLoadingJobs, lodash.isEqual);
      var loadingJobsDeletedFromMemory = lodash.differenceWith(copyOfsavedGSQLLoadingJobs, copyOfInMemoryGSQLLoadingJobs, lodash.isEqual);
      var loadingJobsToAdd = _filterInstanceProperty__default["default"](inMemoryGSQLLoadingJobs).call(inMemoryGSQLLoadingJobs, function (inMemoryGSQLJob) {
        return _findInstanceProperty__default["default"](loadingJobsAddedInMemory).call(loadingJobsAddedInMemory, function (jobAddedInMemory) {
          return inMemoryGSQLJob.JobName === jobAddedInMemory.JobName;
        });
      });
      var loadingJobsToDelete = lodash.unionWith(loadingJobsDeletedFromMemory, loadingJobsAddedInMemory, function (job1, job2) {
        return job1.JobName === job2.JobName;
      });
      var loadingJobNamesToDelete = _mapInstanceProperty__default["default"](loadingJobsToDelete).call(loadingJobsToDelete, function (job) {
        return job.JobName;
      });
      return {
        isChanged: true,
        loadingJobNamesToDelete: loadingJobNamesToDelete,
        loadingJobsToAdd: loadingJobsToAdd
      };
    }

    /**
     * Handle the where clause in the GSQL loading job load statements.
     *
     * @static
     * @param {GSQLLoadingJobJson[]} gsqlLoadingJobs
     * @returns {GSQLLoadingJobJson[]}
     * @memberof GSQLLoadingJobLogic
     */
  }, {
    key: "handleWhereClause",
    value: function handleWhereClause(gsqlLoadingJobs) {
      gsqlLoadingJobs = lodash.cloneDeep(gsqlLoadingJobs);
      _forEachInstanceProperty__default["default"](gsqlLoadingJobs).call(gsqlLoadingJobs, function (gsqlLoadingJob) {
        var _context;
        return _forEachInstanceProperty__default["default"](_context = gsqlLoadingJob.LoadingStatements).call(_context, function (statement) {
          if (statement.WhereClause) {
            // Remove parenthesis from the where clause.
            statement.WhereClause = statement.WhereClause.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '');
          }
        });
      });
      return gsqlLoadingJobs;
    }

    /**
     * Get the unsaved loading jobs that are new or updated.
     *
     * @param {GSQLLoadingJobJson[]} savedGSQLLoadingJobs
     * @param {GSQLLoadingJobJson[]} inMemoryGSQLLoadingJobs
     * @param {LoadingJobData[]} loadingJobs
     */
  }, {
    key: "getUnsavedGSQLLoadingJobNames",
    value: function getUnsavedGSQLLoadingJobNames(savedGSQLLoadingJobs, inMemoryGSQLLoadingJobs) {
      var unsavedJobNames = [];
      _forEachInstanceProperty__default["default"](inMemoryGSQLLoadingJobs).call(inMemoryGSQLLoadingJobs, function (inMemoryGSQLLoadingJob) {
        var oldJob = _findInstanceProperty__default["default"](savedGSQLLoadingJobs).call(savedGSQLLoadingJobs, function (job) {
          return job.JobName === inMemoryGSQLLoadingJob.JobName;
        });
        if (oldJob === undefined || !lodash.isEqual(oldJob, inMemoryGSQLLoadingJob)) {
          // Add new or updated loading jobs.
          unsavedJobNames.push(inMemoryGSQLLoadingJob.JobName);
        }
      });
      return unsavedJobNames;
    }
  }]);
}();

exports.GSQLLoadingJobLogic = GSQLLoadingJobLogic;
